import axios from 'axios'
import { getApiBase } from './config'

const http = axios.create({
  baseURL: getApiBase(),
  timeout: 20000,
  headers: {
    Accept: 'application/json'
  }
})

export default http
